export default "__VITE_ASSET__CLiBq97Z__"